const respondToMainCtaVisibility = function (element, callback) {
    const options = {
      rootMargin: '0px',
      threshold: 1,
    };
  
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        callback(entry.intersectionRatio > 1 || entry.isIntersecting);
      });
    }, options);
  
    observer.observe(element);
  };
  
  const toggleStickyCtaVisibility = (isMainCtaVisible) => {
    const stickyCtaContainer = document.querySelector('.sticky-cta-container');
  
    if (stickyCtaContainer !== null) {
      if (isMainCtaVisible) {
        stickyCtaContainer.classList.add('!tw-hidden');
      } else {
        stickyCtaContainer.classList.remove('!tw-hidden');
      }
    }
  };
  
  document.addEventListener('DOMContentLoaded', () => {
    const mainCtaNode = document.querySelector('.jump-product-cta-visibility');
  
    respondToMainCtaVisibility(mainCtaNode, toggleStickyCtaVisibility);
  });
  